// index.js

import React, { Component } from 'react';
import PropTypes from  'prop-types';
import { inject } from "mobx-react";
import  { withStyles } from  '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import LinearProgress from '@material-ui/core/LinearProgress';
import { StripeProvider } from 'react-stripe-elements';
import StripeStoreCheckout from './StripeStoreCheckout';

const styles = theme => ({
  root: {
    flexGrow: 1
  }
});

@inject("authStore")
class PurchaseForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      stripeDoneLoading: false
    };
  }
  componentDidMount() {
    const { stripeKey } = this.props.authStore
    // componentDidMount only runs in a browser environment.
    // In addition to loading asynchronously, this code is safe to server-side render.
    // You can inject a script tag manually like this,
    // or you can use the 'async' attribute on the Stripe.js v3 <script> tag.
    const stripeJs = document.createElement('script');
    stripeJs.src = 'https://js.stripe.com/v3/';
    stripeJs.async = true;
    stripeJs.onload = () => {
      // The setTimeout lets us pretend that Stripe.js took a long time to load
      // Take it out of your production code!
      setTimeout(() => {
        this.setState({
          stripeDoneLoading: true,
          stripe: window.Stripe(stripeKey)
        });
      }, 500);
    };
    document.body && document.body.appendChild(stripeJs);
  }
  render() {
    console.log('PurchaseForm render');
    if (this.state.stripeDoneLoading) {
      return (
        <StripeProvider stripe={this.state.stripe}>
          <StripeStoreCheckout isPay={'isPay' in this.props ? this.props.isPay : true} gotToken={this.props.gotToken} />
        </StripeProvider>
      );
    } else {
      return (
        <div>
        <Typography variant="subheading" color="textSecondary"> Loading secure payment form ... </Typography>
        <LinearProgress />
        </div>
      );
    }
  }
}


PurchaseForm.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(PurchaseForm);


// WEBPACK FOOTER //
// ./src/components/Stripe/index.js